// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280404/js/" + chunkId + "." + {"44":"956e5368","225":"85724439","481":"2ae9e720","486":"474da037","770":"2e17174b"}[chunkId] + ".0.3941881125437956.chunk.js";
};